import $ from "jquery";

$(function () {
    const toggleSpoiler = (target) => {
        target
            .children()
            .first()
            .toggleClass('show-icon')
            .toggleClass('hide-icon');
        target
            .parent().children().last().toggle();
    };

    $(document).on('click', 'div.spoiler-title', function () {
        toggleSpoiler($(this));
    });

    const spoilerTitle = $(window.location.hash).find('.spoiler-title');

    if (window.location.hash) {
        toggleSpoiler(spoilerTitle);
    }
});
